import AsteriskIcon from '@jetbrains/icons/asterisk.svg'
import Icon, {Size} from '@jetbrains/ring-ui/components/icon'
import classNames from 'classnames'
import React, {memo} from 'react'

import Actions from '../../../../../Actions/Actions'
import PipelineSecretForm from '../PipelineSecretForm/PipelineSecretForm'

import type {PipelineSecretProps} from './PipelineSecret.types'
import usePipelineSecret from './usePipelineSecret'

import styles from './PipelineSecret.css'

function PipelineSecret({originalName, disabled, deleted}: PipelineSecretProps) {
  const {
    secretName,
    isEditMode,
    handlerSecretEditButtonClick,
    handlerSecretDeleteButtonClick,
    handlerSecretRestoreButtonClick,
    handlerSecretCancelEditButtonClick,
    handlerSecretConfirmEditButtonClick,
  } = usePipelineSecret(originalName)
  const secretInputWrapperClasses = classNames(styles.secretInputWrapper, {
    [styles.secretInputWrapperDeleted]: deleted,
  })

  return (
    <div className={styles.secret}>
      {isEditMode ? (
        <PipelineSecretForm
          name={secretName}
          helperText={
            'The secret value is not viewable. You can cancel editing to save old value or write a new one.'
          }
          onConfirm={handlerSecretConfirmEditButtonClick}
          onCancel={handlerSecretCancelEditButtonClick}
          onDelete={handlerSecretDeleteButtonClick}
          isEditMode
        />
      ) : (
        <div className={secretInputWrapperClasses}>
          <div className={styles.secretName}>{secretName}</div>
          {':\u00a0'}
          <span className={styles.secretValue}>
            <Icon glyph={AsteriskIcon} size={Size.Size12} title="hide secret token" />
            <Icon glyph={AsteriskIcon} size={Size.Size12} title="hide secret token" />
            <Icon glyph={AsteriskIcon} size={Size.Size12} title="hide secret token" />
            <Icon glyph={AsteriskIcon} size={Size.Size12} title="hide secret token" />
          </span>
        </div>
      )}
      {!isEditMode && (
        <Actions
          className={styles.secretActions}
          deleted={deleted}
          disabled={disabled}
          onRestoreClick={handlerSecretRestoreButtonClick}
          onEditClick={handlerSecretEditButtonClick}
          onDeleteClick={handlerSecretDeleteButtonClick}
        />
      )}
    </div>
  )
}

export default memo(PipelineSecret)
